export default {
  methods: {
    getMessageError(code) {
      let message = ''
      switch (code) {
        case 'UserNotFoundException':
          message = this.$i18n.t('userDoesNotExist')
          break
        case 'NotAuthorizedException':
          message = this.$i18n.t('incorrectUsernameOrPassword')
          break
        case 'CodeMismatchException':
          message = this.$i18n.t('invalidVerificationCode')
          break
        case 'ExpiredCodeException':
          message = this.$i18n.t('expiredVerificationCode')
          break
        case 'MfaAttemptsExceeded': // código sintético emitido pela tela
          message = this.$i18n.t('mfaAttemptsExceeded')
          break
        case 'MfaResendLimitExceeded': // código sintético emitido pela tela
          message = this.$i18n.t('mfaResendLimitExceeded')
          break
        default:
          message = this.$i18n.t('anUnexpectedErrorHasOccurred')
          break
      }
      return message
    },
  },
}
